<template>
    <v-dialog v-model="dialog" persistent max-width="900">
        <common-card>

            <v-card-text class="pa-4 black--text">
                <div class="pt-5 pb-5 top-text"
                    style="width: 100%; height: 100%; justify-content: center; text-align: center;">
                    Carga Masiva de Disposiciones por campaña
                </div>
                <div class="pt-5 pb-5">
                    <InputCargamasivaDispocisionesOutbound :toSave="toSave" @goTosave="goTosave" :cuentaId="idCampaing"
                        :readOnly="readOnly" :campanias="campanias" />
                </div>
                <div>
                    <v-row style="text-align: end;">
                        <v-col cols="12">
                            <v-btn text color="#00a7e4" outlined style="border-radius: 15px;"
                                @click="$emit('closeModal')">
                                Cancelar</v-btn>
                            &nbsp;&nbsp;
                            <v-btn class="common-botton" dark @click="toSave = true">Procesar</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <CommonActionModal :dialog="dialogEleccion" title="Crear la Campaña Inbound"
                subtitle="¿Deseas Procesar este archivo?" bottonText="Si, creala"
                @userChoice="postPutCampaniaInbound" />
        </common-card>
    </v-dialog>
</template>

<script>
import InputCargamasivaDispocisionesOutbound from "@/components/commonComponents/forms/InputCargamasivaDispocisionesOutbound.vue";
import CommonCard from "../CommonCard.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";

export default {
    props: {
        dialog: {
            type: Boolean,
            default: true,
        },
        lead: {
            type: Object,
            default: () => { },
        },
        campanias: {
            type: Array,
            required: true
        },
        idCampaing: { type: Number, default: null },
        readOnly: { type: Boolean, default: false }
    },
    components: {
        InputCargamasivaDispocisionesOutbound,
        CommonCard,
        CommonActionModal,
    },
    data() {
        return {
            toSave: false
        };
    },
    methods: {
        goTosave({ ok }) {
            this.toSave = false;
            if (ok) {
                this.$emit('closeModal');
            }
        },
    }
};
</script>
<style>
.v-toolbar--dense .v-toolbar__content,
.v-toolbar--dense .v-toolbar__extension {
    padding-top: 0;
    padding-bottom: 0;
    justify-content: center;
}

.top-text {
    width: 369px;
    height: 22px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 110%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #4d5358;
    flex: none;
    order: 0;
    flex-grow: 1;
}

.confirmation-text {
    /* Por favor, asegúrate de revisar cuidadosamente los cambios antes de continuar */

    width: 369px;
    height: 30px;

    /* Subtitle/S */
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 110%;
    /* or 15px */
    text-align: center;

    color: #555555;

    /* Inside auto layout */
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
}
</style>
